exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-title {\n  font-weight: bold;\n  font-size: 18px;\n  margin-top: 5px;\n  margin-bottom: 25px; }\n\n.confirm-button {\n  color: #E74C3C; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-remove-dialog/app-remove-dialog.component.scss
// module id = ../../../../../src/app/components/app-remove-dialog/app-remove-dialog.component.scss
// module chunks = main